// extracted by mini-css-extract-plugin
export var discard = "_2h-4";
export var muiTooltipTooltip = "_2h-6";
export var notificationBar = "_2h-3";
export var notificationContainer = "_2h-2";
export var saveButtonHoverSlotWrapper = "_2h-5";
export var show = "_2h-1";
export var spacer = "_2h-0";